// removed by extract-text-webpack-plugin
module.exports = {"container":"SimpleModal-container","content":"SimpleModal-content","closeButton":"SimpleModal-closeButton","title":"SimpleModal-title","footer":"SimpleModal-footer"};